import React from "react";

export default function SQL_Count() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Count</h1>
      <p>This is the SQL_Count component generated from the SQL JSON.</p>
    </div>
  );
}
